import { record } from 'rrweb';
import type { FlamioConfig } from './types';
import { getRecordConfig, type RecordPrivacySelectors } from './privacy';

export function startRecording(
  config: FlamioConfig,
  selectors: RecordPrivacySelectors,
  onEvent: (event: unknown) => void
): (() => void) | null {
  const privacyConfig = getRecordConfig(config, selectors);
  if (!privacyConfig) return null;

  try {
    const stop = record({
      emit: onEvent,
      ...privacyConfig,
    });
    return stop ?? null;
  } catch {
    return null;
  }
}

/**
 * Forces an rrweb checkout (Meta + FullSnapshot) to anchor the current DOM.
 * rrweb 2.x emits a FullSnapshot only at record() init and every
 * checkoutEveryNms, so an SPA route change leaves the new page without a
 * snapshot — deep-seeking to a friction there would replay off the previous
 * route's DOM. Re-anchoring on navigation fixes the replay/screenshot.
 */
export function takeFullSnapshot(): void {
  try {
    record.takeFullSnapshot(true);
  } catch {
    // noop — recording inactive or rrweb not ready
  }
}
